// extracted by mini-css-extract-plugin
export var md = "_2g-4";
export var semantic = "_2g-5";
export var sm = "_2g-3";
export var text = "_2g-6";
export var toggleInput = "_2g-0";
export var toggleSwitch = "_2g-1";
export var xs = "_2g-2";